import { render, staticRenderFns } from "./AtivarInativarConsultor.vue?vue&type=template&id=e2c7900a&scoped=true"
import script from "./AtivarInativarConsultor.vue?vue&type=script&lang=ts"
export * from "./AtivarInativarConsultor.vue?vue&type=script&lang=ts"
import style0 from "./AtivarInativarConsultor.vue?vue&type=style&index=0&id=e2c7900a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c7900a",
  null
  
)

export default component.exports